import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {ViewEncapsulation} from '@angular/core';
import {EVOL_DEMO_LAST_YEAR} from '@models/empty';

export class TooltipCustomClassExample {}

@Component({
    selector: 'app-habitant',
    templateUrl: './habitant.component.html',
    styleUrls: ['./habitant.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HabitantComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
